import { render, staticRenderFns } from "./FAQ.vue?vue&type=template&id=928c7736"
var script = {}
import style0 from "./FAQ.vue?vue&type=style&index=0&id=928c7736&prod&lang=scss"
import style1 from "./FAQ.vue?vue&type=style&index=1&id=928c7736&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports